module.exports = __webpack_public_path__ + "static/media/user.06526f60.svg";